module.exports = __webpack_public_path__ + "img/PL08591.4fd77cb1.png";